import { CLASSIFICACAO_BACKOFFICE } from '@modules/solicitacoes/constants/classificacao'

// Nome de PRODUTO da persona (spec-008). Faz par com o chat que já existe e se chama
// "IA Operacional" na tela — operacional × estratégico o gestor lê sem manual. "IA CRM Chat"
// é nome de feature flag e nunca aparece na interface.
export const CONSULTOR_ABA_TITULO = 'Consultor Estratégico'

// A 5ª aba é ADICIONADA ao array só com a flag ligada. NavBarNavigation recebe
// [{ title, name }] e não tem noção de "aba desabilitada" — e a AC-1.5 exige ausência, não
// ocultação por CSS: affordance desabilitada que ninguém pode habilitar é ruído permanente.
export const solicitacoesRoutes = ({ consultorEstrategico = false } = {}) => {
  const rotas = [
    { title: 'Visão Geral', name: 'solicitacoes.visao-geral' },
    { title: 'Minhas Solicitações', name: 'solicitacoes.minhas-solicitacoes' },
    { title: 'Catálogo', name: 'solicitacoes.catalogo' },
    { title: 'Comunicação', name: 'solicitacoes.comunicacao' },
  ]
  if (consultorEstrategico) {
    rotas.push({ title: CONSULTOR_ABA_TITULO, name: 'solicitacoes.consultor' })
  }
  return rotas
}

// Copy da faixa de entrada do Consultor na Jornada (spec-008 US-1). Fica no ponto exato do
// "e daí?": logo depois de ver onde está, logo antes da lista que não sabe priorizar.
// DESCRICAO_SEM_CICLO é para quem ainda não definiu ciclo/foco — que é justamente quem mais
// precisa de alguém dizendo por onde começar (journey §7.5).
export const CONSULTOR_BANNER = {
  TITULO: CONSULTOR_ABA_TITULO,
  DESCRICAO:
    'Leio a sua jornada e o catálogo da AAWZ para dizer o que fazer, em que ordem e por quê.',
  DESCRICAO_SEM_CICLO:
    'Ainda não sei seu ciclo e seu foco, mas já consigo situar seu porte e explicar por onde começar.',
  ACAO: 'Abrir consultor',
}

// Falha ao abrir a landing citada na conversa. A mensagem diz o que fazer — bloqueador de
// pop-up é a causa mais comum e o usuário só resolve se souber onde olhar.
export const CONSULTOR_ERRO_ABRIR_LANDING =
  'Este serviço ainda não tem página publicada. Fale com o time AAWZ para solicitá-lo.'

// Modos de exibição da aba Tarefas da Operação AAWZ (toggle local Lista/Kanban — sem Gantt,
// réplica enxuta do board /task/board/list).
export const OPERACAO_AAWZ_TAREFAS_VIEW_LIST = 'list'
export const OPERACAO_AAWZ_TAREFAS_VIEW_KANBAN = 'kanban'
export const OPERACAO_AAWZ_TAREFAS_VIEW_MODES = [
  { key: OPERACAO_AAWZ_TAREFAS_VIEW_LIST, label: 'Lista' },
  { key: OPERACAO_AAWZ_TAREFAS_VIEW_KANBAN, label: 'Kanban' },
]

// Abas da área da Operação AAWZ: Visão Geral (Fila de Trabalho) + Calendário (prazos das
// solicitações) + Tarefas (visão rápida resumida, reusa a task-list-view) + Comunicação (atendente).
export const solicitacoesOperacaoAawzRoutes = () => {
  return [
    { title: 'Visão Geral', name: 'solicitacoes.operacao-aawz.visao-geral' },
    { title: 'Calendário', name: 'solicitacoes.operacao-aawz.calendario' },
    { title: 'Tarefas', name: 'solicitacoes.operacao-aawz.tarefas' },
    { title: 'Comunicação', name: 'solicitacoes.operacao-aawz.comunicacao' },
  ]
}

export const SUBTITULO_OPERACAO_AAWZ_SOLICITACOES =
  'Requisições dos escritórios distribuídas pelos times — visão da operação AAWZ.'

export const MODAL_MARCAR_SERVICO_FEITO =
  'solicitacoes:modal-marcar-servico-feito'
export const MODAL_NOVA_SOLICITACAO_INTERNA =
  'solicitacoes:modal-nova-solicitacao-interna'
// Criação de serviço no catálogo Backoffice (tela admin, escritório interno).
export const MODAL_CATALOGO_NOVO_SERVICO =
  'solicitacoes:modal-catalogo-novo-servico'
// Vínculo de uma corretora de `app_banco` a um serviço do catálogo.
export const MODAL_CATALOGO_NOVA_CORRETORA =
  'solicitacoes:modal-catalogo-nova-corretora'
// Emitido após criar um serviço — a tela do catálogo recarrega a listagem.
export const RELOAD_CATALOGO_BACKOFFICE =
  'solicitacoes:reload-catalogo-backoffice'
// Tipo catch-all do catálogo Backoffice ("Suporte e resoluções do dia a dia",
// migration v620) — usado pela operação AAWZ pra abrir uma solicitação pra
// si mesma (sugestão/dúvida/problema) sem precisar escolher um serviço do
// catálogo nem uma instituição. formulario_schema NULL cai no genérico
// (descrição + cliente opcional + anexo) — mesmo contrato de
// core/formulario_schema.py GENERICO_DEFAULT no backend.
export const CODIGO_TIPO_SUPORTE_INTERNO = 'suporte_dia_a_dia'
export const RELOAD_JORNADA = 'solicitacoes:reload-jornada'
export const FONTE_CONTRATADO = 'contratado'
export const FONTE_AUTO = 'auto_declarado'
export const ESTADO_SERVICO_NAO_FEITO = 'nao_feito'
export const ESTADO_SERVICO_LABELS = {
  [FONTE_CONTRATADO]: 'Feito com a AAWZ',
  [FONTE_AUTO]: 'Realizado por conta própria',
  [ESTADO_SERVICO_NAO_FEITO]: 'Não realizado',
}

export const ESTADO_SERVICO_BADGE = {
  [FONTE_CONTRATADO]: { color: 'blue', icon: '' },
  [FONTE_AUTO]: { color: 'success', icon: '' },
  [ESTADO_SERVICO_NAO_FEITO]: { color: 'secondary', icon: '' },
}

// Paleta categórica de cores dos contextos da jornada. Não há token equivalente em
// design-system/tokens.json (candidata a promoção futura). Consumir SEMPRE via
// resolverCorContexto()/corContexto() de utils/jornadaView — nunca importar direto
// em componente, para manter o fallback (backend → mapa → hash → default) num só lugar.
// Chaves = nomes dos 7 contextos do catálogo (áreas do diagnóstico da planilha
// Banco de Perguntas), normalizados (lowercase, sem acentos) por
// normalizarChaveContexto. Contexto fora do mapa cai no hash da CONTEXTO_PALETTE.
export const CONTEXTO_COLOR = {
  'tese e time': '#2f5d44',
  'canais e aquisicao': '#1d6f9c',
  'captacao e relacionamento': '#2f7d4f',
  'gestao de pessoas': '#7a5cad',
  'alocacao e solucoes patrimoniais': '#b07d11',
  'processos, tecnologia e ia': '#2a7d7d',
  'gestao financeira e governanca': '#8a4b2f',
}

export const CONTEXTO_COLOR_DEFAULT = '#8e8e8e'

export const CONTEXTO_PALETTE = [
  '#2f5d44',
  '#1d6f9c',
  '#2f7d4f',
  '#7a5cad',
  '#b07d11',
  '#8a4b2f',
  '#2a7d7d',
  '#b3433b',
  '#5a6b3a',
]

export const CATEGORIA_POR_CONTEXTO = {
  'processos, tecnologia e ia': 'Tecnologia',
  'gestao financeira e governanca': 'Regulatório',
  'canais e aquisicao': 'Expansão',
  'captacao e relacionamento': 'Expansão',
  'tese e time': 'Serviços',
  'gestao de pessoas': 'Serviços',
  'alocacao e solucoes patrimoniais': 'Serviços',
}

export const CATEGORIA_ORDEM_JORNADA = ['Tecnologia', 'Regulatório', 'Expansão', 'Serviços']

export const CATEGORIA_META_JORNADA = {
  Tecnologia: {
    icon: 'ia-head',
    cor: 'var(--blue)',
    descricao: 'Colocar a plataforma e os dados no ar.',
  },
  Regulatório: {
    icon: 'shield-user',
    cor: 'var(--warning-new)',
    descricao: 'Regularizar e habilitar a operação do escritório.',
  },
  Expansão: {
    icon: 'trend-up',
    cor: 'var(--primary)',
    descricao: 'Ampliar canais, captação e receita.',
  },
  Serviços: {
    icon: 'team-new-ux',
    cor: 'var(--secondary)',
    descricao: 'Estruturar time e entrega ao cliente.',
  },
}

export const CATEGORIA_META_JORNADA_DEFAULT = {
  icon: 'category',
  cor: 'var(--secondary)',
  descricao: '',
}

export const TRILHA_ATRASADO_LABEL = 'Atrasado'
export const TRILHA_ATRASADO_COLOR = 'danger'
export const TRILHA_CATEGORIA_FALLBACK = 'Outros'

export const FOCO_ESTRUTURAR = 'Estruturar'
export const FOCO_EXPANDIR = 'Expandir'
export const FOCO_ESCALAR = 'Escalar'

export const FOCO_META_JORNADA = {
  [FOCO_ESTRUTURAR]: {
    icon: 'building-solo',
    descricao:
      'Ideal se o escritório ainda está se estruturando. Comece por regularizar a operação e colocar a plataforma no ar — é a base que sustenta todo o resto.',
  },
  [FOCO_EXPANDIR]: {
    icon: 'arrow-swap-horizontal',
    descricao:
      'Ideal se a operação já roda e o próximo passo é crescer. Aqui o foco é atrair novos clientes e ampliar a receita por novos canais.',
  },
  [FOCO_ESCALAR]: {
    icon: 'chart-grow',
    descricao:
      'Ideal se o volume cresceu e a operação ficou complexa. Aqui o foco é padronizar a entrega e ganhar eficiência sem perder qualidade.',
  },
}

export const JORNADA_PORTE_DICA =
  'Os valores são referência. Se seu escritório fica entre dois ciclos, escolha pelo indicador mais avançado.'

export const JORNADA_FOCO_DICA =
  'As áreas são referência. Escolha uma frente por vez; o foco apenas prioriza os serviços — as outras continuam disponíveis.'

export const JORNADA_STEP_INFO = {
  porte:
    'Escolha o ciclo que representa o momento do escritório hoje. Ele define quais serviços são recomendados no catálogo e o que conta como obrigatório para avançar — use o AuC sob custódia e o número de profissionais como referência.',
  foco:
    'Escolha a frente que é prioridade agora. O foco destaca a trilha correspondente e ordena os serviços pelo que mais importa neste momento; não bloqueia as outras frentes.',
}

export const MAPA_FOCO_CATEGORIA = {
  [FOCO_ESTRUTURAR]: ['Regulatório', 'Tecnologia'],
  [FOCO_EXPANDIR]: ['Expansão'],
  [FOCO_ESCALAR]: ['Serviços'],
}

export const AREA_TODAS = 'todas'

export const MAX_ANEXO_SIZE_MB = 10

export const ANEXO_TYPES = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.xlsx',
  '.docx',
]

export const PRIORIDADE_OPTIONS_SOLICITACOES = [
  { text: 'Urgente', value: 'urgente' },
  { text: 'Alta', value: 'alta' },
  { text: 'Média', value: 'media' },
  { text: 'Baixa', value: 'baixa' },
]

export const STATUS_SOLICITACAO = ['aberto', 'em andamento', 'encerrado']

export const STATUS_CONFIG_SOLICITACOES = {
  aberto: { label: 'Aberta', statusColor: 'blue' },
  'em andamento': { label: 'Em andamento', statusColor: 'warning-new' },
  em_andamento: { label: 'Em andamento', statusColor: 'warning-new' },
  encerrado: { label: 'Encerrada', statusColor: 'success' },
  cancelado: { label: 'Cancelada', statusColor: 'danger' },
  default: { label: 'Indefinido', statusColor: 'secondary' },
}

// Mapa dos 7 status da esteira Backoffice (data-model.md §2b) — movido de
// `ws/views/view-ws-solicitacao-detalhe.vue` (T012, US-4) para ser a fonte ÚNICA
// consumida tanto pelo detalhe do WS (consultor) quanto pelo seletor de status do
// detalhe da Operação AAWZ (T006, backoffice interno). É distinto do vocabulário
// legado (aberto/em andamento/encerrado) do Hub estratégico — ver
// `STATUS_SOLICITACAO`/`STATUS_CONFIG_SOLICITACOES` acima. Cores da paleta oficial
// de feedback (nunca hex fora da escala).
// Cores por NOME SEMÂNTICO (o BaseStatus resolve para `var(--<nome>)`), nunca
// hex cru — mesmo padrão de `SOLICITACOES_PEDIDO_STATUS_MAP`
// (`@modules/solicitacoes/constants/comunicacao.js`).
// `color` é nome de TOKEN que o BaseStatus resolve para `var(--<token>)`, então
// só vale token EMITIDO como CSS custom property (`$theme-colors` em
// design/_vars.sass: primary, secondary, success, danger, warning, await...).
// `warning-new` NÃO entra nessa lista — existe só como variável SASS, e usá-lo
// gerava `var(--warning-new)`, inexistente: os dois "Aguardando" apareciam SEM
// COR. Mesma ressalva já registrada em solicitacoes/constants/comunicacao.js.
//
// As duas esperas têm cores DIFERENTES de propósito: "Aguardando você" cobra
// ação do consultor (amarelo, ele resolve), "Aguardando terceiros" está parada
// na corretora/banco (laranja, ninguém aqui destrava). Mesma cor nas duas
// apagava justamente a distinção que o CTO pediu.
export const STATUS_BACKOFFICE_INFO = {
  aberto: { label: 'Aberta', color: 'secondary' },
  em_atendimento: { label: 'Em atendimento', color: 'primary' },
  aguardando_solicitante: { label: 'Aguardando você', color: 'await' },
  aguardando_terceiros: { label: 'Aguardando terceiros', color: 'warning' },
  resolvido: { label: 'Resolvida', color: 'success' },
  fechado: { label: 'Fechada', color: 'secondary' },
  // T021 (US-4): status terminal do cancelamento pelo consultor — vermelho
  // porque, ao contrário de "Resolvida"/"Fechada", sinaliza que a solicitação
  // não foi atendida.
  cancelado: { label: 'Cancelada', color: 'danger' },
}

// Ordem canônica da esteira Backoffice — usada pelo seletor de status (T006) para
// oferecer as opções na sequência real do fluxo, não na ordem de inserção do objeto.
export const STATUS_BACKOFFICE_ORDEM = Object.keys(STATUS_BACKOFFICE_INFO)

// Status TERMINAIS de uma solicitação — fonte ÚNICA para as duas telas de
// detalhe (o do WS, `view-ws-solicitacao-detalhe.vue`, e o do time interno,
// `operacao-aawz/view-operacao-aawz-detalhe.vue`), que antes declaravam o
// mesmo conjunto cada uma. Deliberadamente MAIOR que `STATUS_BACKOFFICE_INFO`:
// 'encerrado' é vocabulário legado do Hub estratégico que a esteira Backoffice
// pode herdar pela mesma tabela, então quem lê "acabou?" precisa reconhecê-lo.
export const STATUS_SOLICITACAO_FINAIS = new Set([
  'encerrado',
  'resolvido',
  'fechado',
  'cancelado',
])

// Resolve o rótulo/cor de exibição do STATUS de uma linha da fila — fonte ÚNICA
// consumida por `atuais-tabela.vue` (tabela COMPARTILHADA entre o Hub estratégico
// e a fila Backoffice do Wealth Service). Cada esteira tem vocabulário PRÓPRIO
// (`STATUS_CONFIG_SOLICITACOES` no Hub, `STATUS_BACKOFFICE_INFO` no WS); resolver
// por `STATUS_CONFIG_SOLICITACOES` sozinho para QUALQUER linha (gap G-4, QA E2E
// spec-002-fila-backoffice-ws) faz 5 dos 7 status do Backoffice
// (`em_atendimento`, `aguardando_solicitante`, `aguardando_terceiros`,
// `resolvido`, `fechado`) caírem no `default: 'Indefinido'` — só `aberto` e
// `cancelado` (presentes nos dois mapas) acertavam por coincidência.
// Normaliza os dois shapes (`STATUS_BACKOFFICE_INFO.color` vs
// `STATUS_CONFIG_SOLICITACOES.statusColor`) num só formato, para não espalhar
// ternário de classificação pelo template.
export function statusInfoDaLinha(item) {
  const status = item && item.status
  if (item && item.classificacao === CLASSIFICACAO_BACKOFFICE) {
    const infoBackoffice = STATUS_BACKOFFICE_INFO[status]
    if (infoBackoffice) {
      return { label: infoBackoffice.label, statusColor: infoBackoffice.color }
    }
  }
  const config = STATUS_CONFIG_SOLICITACOES[status] || STATUS_CONFIG_SOLICITACOES.default
  return { label: config.label, statusColor: config.statusColor }
}

// Opções de status do select, escolhidas pela CLASSIFICAÇÃO da solicitação
// (data-model.md §2b): a esteira `backoffice` usa os 7 status de
// `STATUS_BACKOFFICE_INFO`; qualquer outra classificação (`estrategico` ou
// ausente) usa o vocabulário legado do Hub (`STATUS_SOLICITACAO`).
export function statusOptionsPorClassificacao(classificacao) {
  if (classificacao === CLASSIFICACAO_BACKOFFICE) {
    return STATUS_BACKOFFICE_ORDEM.map((value) => ({
      value,
      label: STATUS_BACKOFFICE_INFO[value].label,
    }))
  }
  return STATUS_SOLICITACAO.map((s) => ({
    value: s,
    label: (STATUS_CONFIG_SOLICITACOES[s] || {}).label || s,
  }))
}

// 'cancelado' entra como status terminal real (spec cancelar-solicitacao, 03/09/2026):
// até então só existia como valor de exibição em STATUS_TRANSICOES_SOLICITACOES.
// Usada em filtros de status (select de "Minhas Solicitações" e da Operação AAWZ) —
// canceladas continuam filtráveis explicitamente.
export const STATUS_OPTIONS_SOLICITACOES = [
  { id: 'aberto', value: 'Aberto' },
  { id: 'em andamento', value: 'Em andamento' },
  { id: 'encerrado', value: 'Encerrado' },
  { id: 'cancelado', value: 'Cancelada' },
]

// Decisão de produto (spec cancelar-solicitacao, 03/09/2026): o gráfico "Por status" da
// Central/Minhas Solicitações mantém os 3 buckets canônicos (aberto / em andamento /
// encerrado). Cancelada é status terminal escondido por padrão da lista e NÃO vira bucket
// no gráfico — mostrar cancelamento junto de conclusão distorceria a leitura de "quanto
// foi resolvido". Usar SOMENTE em montarGraficoStatus (minhas-graficos.js); filtros de
// status continuam usando STATUS_OPTIONS_SOLICITACOES (os 4).
export const STATUS_OPTIONS_GRAFICO_SOLICITACOES = STATUS_OPTIONS_SOLICITACOES.filter(
  (opcao) => opcao.id !== 'cancelado'
)

export const PM_TASK_STATUS_TODO = 'todo'
export const PM_TASK_STATUS_DOING = 'doing'
export const PM_TASK_STATUS_DONE = 'done'

export const PM_TASK_STATUS_LABELS = {
  [PM_TASK_STATUS_TODO]: 'A fazer',
  [PM_TASK_STATUS_DOING]: 'Em andamento',
  [PM_TASK_STATUS_DONE]: 'Concluído',
}

export const PM_TASK_STATUS_COLORS = {
  [PM_TASK_STATUS_TODO]: 'secondary',
  [PM_TASK_STATUS_DOING]: 'warning-new',
  [PM_TASK_STATUS_DONE]: 'success',
}

export const SLA_CONFIG_SOLICITACOES = {
  vencido: { label: 'Vencido', color: 'danger', icon: 'warning-status', hex: '#EB5757' },
  emRisco: { label: 'Em risco', color: 'warning-new', icon: 'clock', hex: '#E0AF00' },
  noPrazo: { label: 'No prazo', color: 'success', icon: 'clock', hex: '#56AF79' },
  concluido: { label: 'Concluída', color: 'success', icon: 'check-circle', hex: '#56AF79' },
}

export const ICONE_TIPO_DEFAULT = 'document'

export const ICONE_TIPO_MAP = {
  chart: 'chart-finance',
  search: 'analyze-market',
  users: 'users',
  document: 'document',
  calculator: 'icons-math',
  'document-text': 'document-text',
  briefcase: 'building-solo',
  settings: 'setting',
  support: 'question',
  'chart-pie': 'graph-pie',
  'trending-up': 'trend-up',
}

export const MINHAS_STATUS_CONFIG_SOLICITACOES = {
  aguardando_voce: { key: 'aguardando_voce', label: 'Aguardando você', color: '#B36A00', bg: 'rgba(255, 153, 10, 0.12)' },
  em_andamento: { key: 'em_andamento', label: 'Em andamento', color: '#245CA6', bg: 'rgba(36, 92, 166, 0.1)' },
  em_triagem: { key: 'em_triagem', label: 'Em triagem', color: '#0A6E91', bg: 'rgba(0, 166, 222, 0.13)' },
  aberta: { key: 'aberta', label: 'Aberta', color: '#52525B', bg: '#F1F1F3' },
  concluida: { key: 'concluida', label: 'Concluída', color: '#2E7340', bg: 'rgba(57, 142, 74, 0.1)' },
  default: { key: 'aberta', label: 'Aberta', color: '#52525B', bg: '#F1F1F3' },
}

export const getMinhasStatusConfigSolicitacoes = (status) => {
  return MINHAS_STATUS_CONFIG_SOLICITACOES[status] || MINHAS_STATUS_CONFIG_SOLICITACOES.default
}

export const MINHAS_CHIPS_SOLICITACOES = [
  { key: 'todas', label: 'Todas', tone: 'neutral' },
  { key: 'aguardando', label: 'Aguardando você', tone: 'warning', estado: 'aguardando_voce' },
  { key: 'andamento', label: 'Em andamento', tone: 'neutral', estado: 'em_andamento' },
  { key: 'resolvidas', label: 'Resolvidas', tone: 'neutral', estado: 'concluida' },
]

export const SLA_OPTIONS_SOLICITACOES = [
  { text: 'Todos', value: null },
  { text: 'No prazo', value: 'noPrazo' },
  { text: 'Em risco', value: 'emRisco' },
  { text: 'Vencido', value: 'vencido' },
]

export const STATUS_TRANSICOES_SOLICITACOES = [
  { text: 'Em andamento', value: 'em_andamento' },
  { text: 'Encerrada', value: 'encerrado' },
  { text: 'Cancelada', value: 'cancelado' },
]

export const CANAL_CONFIG_SOLICITACOES = {
  whatsapp: { label: 'WhatsApp', icon: 'whatsapp', color: 'primary', badgeColor: '#25D366', acao: 'Abrir conversa' },
  email: { label: 'E-mail', icon: 'email', color: '#6A7086', badgeColor: '#245CA6', acao: 'Abrir conversa' },
  reuniao: { label: 'Reunião', icon: 'calendar', color: '#2C5BC2', badgeColor: '#2C5BC2', acao: 'Abrir resumo' },
  default: { label: 'Canal', icon: 'message', color: 'secondary', badgeColor: 'var(--secondary, #71717A)', acao: 'Abrir' },
}

export const getCanalConfigSolicitacoes = (canal) => {
  return CANAL_CONFIG_SOLICITACOES[canal] || CANAL_CONFIG_SOLICITACOES.default
}

export const COLUNAS_FILA_SOLICITACOES = [
  { value: 'solicitanteNome', text: 'Escritório / Solicitante' },
  { value: 'areaNome', text: 'Área' },
  { value: 'tipoNome', text: 'Tipo' },
  { value: 'responsavel', text: 'Responsável' },
  { value: 'status', text: 'Status' },
  { value: 'sla', text: 'SLA' },
  { value: 'progresso', text: 'Progresso' },
  { value: 'dataRegistro', text: 'Abertura' },
  { value: 'actions', text: 'Ações', obrigatoria: true },
]

export const COLUNAS_FILA_DEFAULT = COLUNAS_FILA_SOLICITACOES.map((c) => c.value)

export const FILA_STORAGE_KEYS = {
  colunas: 'solicitacoes_fila_colunas',
}

export const CRIAR_STEPS_SOLICITACOES = [
  { numero: 1, chave: 'area', titulo: 'Área', descricao: 'Para qual área é a solicitação?' },
  { numero: 2, chave: 'template', titulo: 'Template', descricao: 'Escolha o template que melhor descreve a demanda.' },
  { numero: 3, chave: 'confirmar', titulo: 'Confirmar', descricao: 'Revise os detalhes e abra a solicitação.' },
]

export const buildMensagemWhatsappAuto = ({
  clienteNome,
  areaNome,
  tipoNome,
  descricao,
  timeNome,
} = {}) => {
  const linhas = [
    'Olá, ' + (timeNome || 'Time AAWZ') + '! Nova solicitação aberta por ' + (clienteNome || 'cliente') + '.',
    'Área: ' + (areaNome || '-'),
    'Tipo: ' + (tipoNome || '-'),
  ]
  if (descricao && descricao.trim()) {
    linhas.push('Detalhes: ' + descricao.trim())
  }
  return linhas.join('\n')
}

export const CONFIG_JORNADA_ETAPA = {
  ABA: 'Jornada por etapa',
  DESCRICAO:
    'Defina quais serviços são obrigatórios em cada etapa da jornada. A alteração é salva automaticamente.',
  HEADER_SERVICO: 'Serviço',
  HEADER_CONTEXTO: 'Contexto',
  HEADER_ENTRADA: 'Entrada',
  FILTRO_CONTEXTO_LABEL: 'Contexto',
  FILTRO_CONTEXTO_TODOS: 'Todos os contextos',
  BUSCA_PLACEHOLDER: 'Buscar serviço',
  BADGE_OBRIGATORIO: 'Obrigatório',
  BADGE_OPCIONAL: 'Opcional',
  BADGE_COLOR_OBRIGATORIO: 'primary',
  BADGE_COLOR_OPCIONAL: 'secondary',
  TOOLTIP_NAO_PARTICIPA: (nivel) =>
    `Este serviço entra na jornada no C${nivel}`,
  VAZIO: 'Nenhum serviço com etapa definida no catálogo.',
  SNACK_ERRO:
    'Não foi possível atualizar o vínculo. Tente novamente mais tarde.',
  RODAPE_SEM_ETAPA: (n) =>
    `${n} serviços sem etapa definida não são exibidos.`,
}

export const FILTRO_OBRIGATORIOS = 'obrigatorios'

export const OBRIGATORIO_LABELS = { true: 'Obrigatório', false: 'Opcional' }

export const OBRIGATORIO_BADGE = {
  obrigatorio: { color: 'warning' },
  opcional: { color: 'gray-6' },
}

export const STATUS_META_JORNADA = {
  done: { label: 'Contratado', color: 'success' },
  exec: { label: 'Em execução', color: 'warning' },
  rec: { label: 'Sugerido', color: 'blue' },
}

export const META_ATRASADO_JORNADA = {
  label: TRILHA_ATRASADO_LABEL,
  color: TRILHA_ATRASADO_COLOR,
}

export const TEXTO_OPCIONAIS_NAO_BLOQUEIAM =
  'Serviços opcionais não bloqueiam seu avanço de fase.'

export const META_SEM_OBRIGATORIOS = 'Sem obrigatórios nesta fase'

// ── Landing do serviço (spec-006 — funil comercial) ─────────────────────────
// Canal do GlobalBus do modal de confirmação do CTA "Falar com o time
// comercial" (US-2/RN-03) — abre modal-acionar-comercial.vue, que só coleta a
// observação opcional e emite `confirmar` para quem tem o contexto do serviço.
export const SOLICITACOES_MODAL = {
  LANDING_CTA_COMERCIAL: 'solicitacoes_landing_cta_comercial_modal',
}

// 4 passos fixos do processo comercial exibidos na landing do serviço
// (AC-1.3). São FIXOS — não derivam do serviço. Ícones validados em
// src/components/icons/svg/ (nome inexistente não some — IconSVG imprime a
// string crua na tela): lamp-on, people-profile, document-text e
// route-square existem.
export const LANDING_PROCESSO_COMERCIAL_STEPS = [
  {
    numero: 1,
    chave: 'entender',
    titulo: 'Entender o serviço',
    descricao:
      'Apresentamos o escopo, os entregáveis e como o serviço se conecta ao momento do seu escritório.',
    icone: 'lamp-on',
  },
  {
    numero: 2,
    chave: 'reuniao',
    titulo: 'Reunião comercial',
    descricao:
      'Uma conversa direta com o time comercial da AAWZ para alinhar objetivos, prazos e condições.',
    icone: 'people-profile',
  },
  {
    numero: 3,
    chave: 'contrato',
    titulo: 'Contrato',
    descricao: 'Formalização do escopo, dos entregáveis e do investimento acordado.',
    icone: 'document-text',
  },
  {
    numero: 4,
    chave: 'plano-90-dias',
    titulo: 'Plano de 90 dias',
    descricao: 'Execução com cronograma definido e acompanhamento das primeiras entregas.',
    icone: 'route-square',
  },
]

// Títulos das seções de conteúdo da landing (AC-1.2). "O que é" é o hero —
// não tem título de seção próprio, é a abertura da página.
export const LANDING_SECAO_TITULOS = {
  PRA_QUEM_E: 'Para quem é',
  DORES: 'Que dores resolve',
  ENTREGAVEIS: 'Entregáveis',
  PROCESSO_COMERCIAL: 'Como funciona o processo comercial',
}

// CTA principal da landing (US-2/US-4). O estado "acionado" é lido do lead,
// nunca do e-mail — a plataforma não detecta falha de SES (RN-15).
export const LANDING_CTA_LABEL = 'Falar com o time comercial'

// Monta o rótulo do CTA já acionado. `dataAcionamento` chega pronta (dd/mm)
// do componente — esta função só compõe a frase (RN-23/AC-4.1).
export const buildLandingCtaAcionadoLabel = ({ dataAcionamento } = {}) => {
  return (
    'Time comercial acionado em ' +
    (dataAcionamento || '-') +
    ' — entramos em contato em breve'
  )
}

// Fallbacks para quando a resposta da API não tem `message` (ex.: falha de
// rede antes de chegar no backend). Uso preferencial continua sendo
// $showSnack(r) com a resposta direta — estas strings só cobrem o caso sem
// envelope de API.
export const LANDING_CTA_SUCESSO_FALLBACK = 'Time comercial acionado com sucesso.'
export const LANDING_CTA_ERRO_FALLBACK =
  'Não foi possível acionar o time comercial agora. Tente novamente em instantes ou contate o suporte.'

// Copy do modal de confirmação do CTA (SOLICITACOES_MODAL.LANDING_CTA_COMERCIAL).
// A observação é opcional — dá contexto sem reintroduzir o formulário de
// contratação que saiu do fluxo do cliente (RN-03).
export const LANDING_CTA_MODAL_TEXT = {
  titulo: 'Falar com o time comercial',
  descricao:
    'Ao confirmar, o time comercial da AAWZ é acionado e entra em contato para os próximos passos. Se quiser, deixe uma observação para contextualizar o assunto.',
  observacaoLabel: 'Observação (opcional)',
  observacaoPlaceholder: 'O que você gostaria de esclarecer com o time comercial?',
  confirmar: 'Confirmar',
}

// Fallback de cor do bloco visual da landing (D13). 9/9 áreas do catálogo têm `cor`
// cadastrada (`aawz_servicos_areas.cor` — research.md spec-006 §8), então este hash só
// cobre o caso órfão (tipo sem área resolvida — ex.: serviço legado/dado incompleto).
// Paleta DEDICADA — não reusa CONTEXTO_PALETTE (acima): área (`aawz_servicos_areas`) e
// contexto (`aawz_servicos_contextos`) são tabelas/domínios distintos do catálogo, e
// aquela paleta é de uso exclusivo de corContexto()/resolverCorContexto() (ver aviso
// na doc de CONTEXTO_PALETTE).
export const AREA_COR_PALETTE = [
  '#2f5d44',
  '#1d6f9c',
  '#2f7d4f',
  '#7a5cad',
  '#b07d11',
  '#8a4b2f',
  '#2a7d7d',
  '#b3433b',
  '#5a6b3a',
]

export const AREA_COR_DEFAULT = '#8e8e8e'

const LIMITE_32_BITS = 4294967296
const MAIOR_INTEIRO_COM_SINAL = 2147483648

const paraInteiroDe32BitsComSinal = (numero) => {
  const resto = numero % LIMITE_32_BITS
  if (resto >= MAIOR_INTEIRO_COM_SINAL) return resto - LIMITE_32_BITS
  if (resto < -MAIOR_INTEIRO_COM_SINAL) return resto + LIMITE_32_BITS
  return resto
}

const hashParaIndiceArea = (texto, tamanho) => {
  const str = String(texto)
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = paraInteiroDe32BitsComSinal(hash * 31 + str.codePointAt(i))
  }
  return Math.abs(hash) % tamanho
}

// Resolve a cor do bloco visual da landing: `tipo.cor` → `area.cor` → hash
// determinístico na paleta (chave = id/nome disponível) → cinza neutro (tipo sem
// nenhum identificador, caso teórico). Único ponto que decide essa cadeia — não
// duplicar a lógica em componente.
export const resolverCorArea = ({ tipo, area } = {}) => {
  if (tipo && tipo.cor) return tipo.cor
  if (area && area.cor) return area.cor
  const chave =
    (tipo && (tipo.id || tipo.nome)) || (area && (area.id || area.area))
  if (!chave) return AREA_COR_DEFAULT
  return AREA_COR_PALETTE[hashParaIndiceArea(chave, AREA_COR_PALETTE.length)]
}
